<template>
  <div class="buy">
    <div class="buy_box">
      <router-link
        to="/order_list/order_underway"
        replace
        :class="index_active == 1 ? 'active' : ''"
      >
        <div>{{ $t("main.text66") }}</div>
      </router-link>
      <router-link
        to="/order_list/order_done"
        replace
        :class="index_active == 2 ? 'active' : ''"
      >
        <div>{{ $t("main.text67") }}</div>
      </router-link>
    </div>
    <div class="view_box">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      index_active: 1,
    };
  },
  beforeMount() {
    sessionStorage.setItem("hichat_title", this.$t("main.text68"));
    sessionStorage.setItem("hichat_return_home", true);
  },
  beforeDestroy() {
    sessionStorage.setItem("hichat_return_home", "");
  },
  mounted() {
    this.set_active();
  },
  watch: {
    $route() {
      this.set_active();
    },
  },
  methods: {
    set_active() {
      if (this.$route.path == "/order_list/order_underway") {
        this.index_active = 1;
      } else if (this.$route.path == "/order_list/order_done") {
        this.index_active = 2;
      }
    },
  },
};
</script>

<style scoped>
.buy_box {
  display: flex;
  background: #f5f6f7;
}
.buy_box a {
  width: 50%;
  text-align: center;
  box-sizing: border-box;
  padding: 0.65rem 0;
}
.active {
  color: #fff;
  background: #2982d8;
}
.active a {
  color: #fff;
}
/* .view_box {
  box-sizing: border-box;
  padding: 1rem;
} */
</style>
